import { makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles((theme) => ({
    modalBody: {
        paddingTop: theme.spacing(2),
    },
    container: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        textAlign: 'center',
        padding: theme.spacing(2, 4, 4),
    },
    icon: {
        fontSize: 56,
        color: theme.palette.primary.main,
        marginBottom: theme.spacing(2),
    },
    title: {
        color: theme.palette.primary.main,
        fontWeight: 'bold',
        marginBottom: theme.spacing(3),
    },
    description: {
        marginBottom: theme.spacing(3),
        fontSize: '1rem',
        color: theme.palette.text.primary,
    },
    list: {
        textAlign: 'left',
        marginBottom: theme.spacing(4),
        paddingLeft: theme.spacing(3),
        listStyleType: 'disc',
        width: '100%',
        '& li': {
            marginBottom: theme.spacing(1),
        },
    },
    actionsContainer: {
        display: 'flex',
        justifyContent: 'center',
        gap: theme.spacing(2),
        width: '100%',
    },
    cancelButton: {
        textTransform: 'none',
        fontWeight: 'bold',
        minWidth: '160px',
    },
    confirmButton: {
        textTransform: 'none',
        fontWeight: 'bold',
        minWidth: '160px',
        boxShadow: 'none',
    },
}));
